/**
 * @generated SignedSource<<d396bb4c98ba486fccd055de86fd7483>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ParticipantFragment$data = {
  readonly avatarUrl: string;
  readonly login: string;
  readonly " $fragmentType": "ParticipantFragment";
};
export type ParticipantFragment$key = {
  readonly " $data"?: ParticipantFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ParticipantFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipantFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": 64
        }
      ],
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": "avatarUrl(size:64)"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9c347e2beafe5526658002277ba71da7";

export default node;
